import {
  APEX_CLASS,
  APEX_TRIGGER,
  APPROVAL_PROCESS,
  FIELD,
  FLOW,
  OBJECT,
  PROCESS_BUILDER_FLOW,
  VALIDATION_RULE,
  WORKFLOW_RULE,
  LAYOUT,
  RECORD_TYPE,
} from '@server/parser';
import { SalesforceItem } from '../../parser/ParserTypes';

export enum SearchType {
  apiNameAndLabel = 'NAME_LABEL_SEARCH',
  content = 'CONTENT_SEARCH',
}

export type SearchResponseWithConfigurationItems = {
  [APEX_CLASS]: SalesforceItem[];
  [APEX_TRIGGER]: SalesforceItem[];
  [APPROVAL_PROCESS]: SalesforceItem[];
  [FIELD]: SalesforceItem[];
  [FLOW]: SalesforceItem[];
  [OBJECT]: SalesforceItem[];
  [PROCESS_BUILDER_FLOW]: SalesforceItem[];
  [VALIDATION_RULE]: SalesforceItem[];
  [WORKFLOW_RULE]: SalesforceItem[];
  [LAYOUT]: SalesforceItem[];
  [RECORD_TYPE]: SalesforceItem[];
  [type: string]: SalesforceItem[];
};
